module.exports = __webpack_public_path__ + "static/media/logologin.55ab71ae.png";